import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector, useDispatch } from 'react-redux';
import { BasketPopup } from '../components/basket/basket-popup/BasketPopup';
import { basketActions } from '../redux/basket/actions/BasketActions.creators';
import { makeGetBasketPopupState } from '../redux/basket/selectors/BasketSelector';
const BasketPopupContainer = ({ recommendations, enablePriceReference, }) => {
    const basketPopupState = useSelector(makeGetBasketPopupState());
    const dispatch = useDispatch();
    const handlePopupClose = () => dispatch(basketActions.createPopupCloseAction());
    return (_jsx(BasketPopup, { isOpen: !basketPopupState.collapsed, closePopup: handlePopupClose, basketProductData: basketPopupState.basketProductData, status: basketPopupState.status, errorCode: basketPopupState.errorCode, isBulk: basketPopupState.isBulk, price: basketPopupState.price, enablePriceReference: enablePriceReference, recommendations: recommendations }));
};
export default BasketPopupContainer;
